deterministicStringify